<style lang="sass" scoped>
.tabTwo
  // height: 100%
  .sr-ctn
    padding: 15px 0
    display: flex
    height: 410px
  .half
    width: 50%
    display: inline-block
    padding-bottom: 10px
    padding: 0 50px
    &:first-child
      border-right: 1px solid #7825FA
  .half_top
    width: 50%
    line-height: 50px
    background: #FBFCFD
    display: inline-block
    color: #3B3F45
    font-weight: normal
    padding-left: 20px
    border-top: 1px solid #EAEBF0
    border-bottom: 1px solid #EAEBF0
    &.line
      border-right: 1px solid #EAEBF0
  .btm_ctn
    height: calc(100% - 50px)
    padding: 15px 0
    .data_ctn
      display: flex
      height: 100%
    .data_none
      text-align: center
      font-size: 12px
      color: #3B3F45
      width: 100%
      line-height: 150px
      span
        color: #3083F2
        cursor: pointer

  .btm-half
    display: inline-block
    width: 50%
    min-width: 540px
    padding: 0 20px
    font-size: 12px
    font-weight: bold
    color: #878A92
    position: relative
    &.l
      border-right: 1px solid #7825FA
    .up-list
      margin-bottom: 10px
      border: 1px solid #EAEBF0
      position: relative
      cursor: pointer
      color: #3B3F45
      &.active
        left: 21px
        border-top: 1px solid #7825FA
        border-bottom: 1px solid #7825FA
        border-left: 2px solid #7825FA
        border-right: 1px solid #EAEBF0
    .x
      position: absolute
      top: -8px
      left: -8px
      font-size: 16px
      color: #FF3973
      background: #fff
      cursor: pointer
    .label, .value
      width: 100%
      display: inline-block
    .label
      height: 30px
      line-height: 30px
      background: #FBFCFD
      border-bottom: 1px solid #EAEBF0
    .value
      line-height: 40px
    .l, .c, .r
      display: inline-block
      text-align: center
      float: left
    .l, .r
      width: 80px
    .l
      border-right: 1px solid #EAEBF0
    .r
      border-left: 1px solid #EAEBF0
      .value
        color: #3083F2
        font-size: 20px
        &.grey
          color: #878A92
          font-size: 12px
          font-weight: normal
    .c
      width: calc(100% - 160px)
      position: relative
      height: 70px
      overflow: hidden
      > span
        display: inline-block
        position: relative
      .label, .value
        margin: 0 -5px
        height: 28px
        border-bottom: none
      .label
        font-weight: normal
        color: #878A92
      .bg-color
        background: #FBFCFD
        position: absolute
        z-index: 0
        left: 0
        top: 0
        width: 100%
        height: 30px
        border-bottom: 1px solid #EAEBF0
      .space
        display: inline-block
        width: 10px
        font-size: 16px
        position: relative
        .label, .value
          margin: 0
        .label
          color: #EAEBF0
          font-size: 16px
    .res_none
      height: 100%
      padding-top: 25%
      text-align: center
      background: #FBFCFD
      color: #3B3F45
      font-weight: normal
    #bar, .bar
      height: 100%

  .spot_btn
    width: 100%
    position: absolute
    bottom: -10px
    left: 0
    text-align: center
    .spot
      display: inline-block
      width: 6px
      height: 6px
      border-radius: 6px
      border: 1px solid #C3C6D6
      margin: 0 5px
      cursor: pointer
      &.cur
        background: #3083F2
        border: 1px solid #3083F2

  .del_main
    font-weight: normal
    width: 310px
    margin: 30px auto
    line-height: 20px
    span
      color: #3083F2

  .clear
    clear: both

</style>

<style lang="scss">
.del_pop.report {
  text-align: center;
  .el-dialog__footer {
    text-align: center;
    border-top: 1px solid #E9E9E9;
    .fix-btn {
      width: 100px;
    }
  }
}
</style>

<template lang="pug">

  .tabTwo
    .sr-ctn
      .half
        SexRate(:data="sexData" @click="item => activeSexData = item" :canClick="true")
      .half(v-if="activeSexData && activeSexData.list && activeSexData.list.length")
        SexRate(:data="activeSexData")
    div(style="height: 330px;")
      .half_top.line 目标分析
      .half_top 时段流量分布
      .btm_ctn
        .data_none(v-if="userPfList.length === 0") 暂无画像数据
          //- span(@click="showPf = true") 立即新增
        .data_ctn(v-else)
          .btm-half.l
            template(v-for="(item, i) in userPfList")
              transition(mode="out-in")
                .up-list(
                  v-show="item.show"
                  :class="{ 'active': curActiveUpfIdx === userPfList.indexOf(item) }"
                  @click="chooseActive(item)")
                  .l
                    .label 画像{{ newPfNames[i] }}
                    .value 标签组合
                  .c
                    .bg-color
                    template(v-if="item.list" v-for="(it, z) in item.list")
                      span
                        .label {{ it.groupName }}
                        .value {{ it.name }}
                      span.space(v-if="z < item.list.length - 1")
                        .label |
                        .value +
                  .r
                    .label 流量占比
                    .value.Akrobat(v-if="item.state != 1") {{ (item.targetNumRate * 100).toFixed(2) }}%
                    .value.Akrobat.grey(v-else) 计算中...
                  //- i.el-icon-error.x(@click.stop="clickDelUserPf(item)")
                  .clear
            //- el-dialog(
              :visible.sync="showDelConfirm" title="温馨提示" width="390px"
              height="260px" custom-class="del_pop report")
              .del_main(v-if="delUserPf") 您正在删除目标"画像{{ newPfNames[userPfList.indexOf(delUserPf)] }}"（{{ delUserPf.list.map(el => el.name).join('+') }}）；删除后
                span 目标流量将减少
                | ，并且
                span 无法复原
                | ，请确认
              div(slot="footer")
                .fix-btn.red(@click="handleDelUserPf") 确定
                .fix-btn(@click="delCancel") 再想想
            .spot_btn(v-if="spots.length > 1")
              .spot(v-for="(item, i) in spots" :class="{ 'cur': spotIdx == i }" @click="clickSpot(i)")
          .btm-half(v-if="curActiveUpf")
            .res_none(v-if="curActiveUpf.state == 1") 数据计算中，请稍后查看
            .bar(v-else-if="curActiveUpf.state == 2")
              #bar(ref="Bar")
            .res_none(v-else) 数据计算失败
</template>

<script>
import echarts from 'echarts'
console.log('echarts')
console.log(echarts)
// import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/legend'

import SexRate from './SexRate.vue'
export default {
  name: "FlowPro",
  props: [ 'codes', 'time' ],
  components: { SexRate },
  data () {
    return {
      canReq: false,
      isNoData: true,

      sexData: { title: '人群分布', list: [] },
      activeSexData: { title: '', list: [] },

      orderCode: '',

      showPf: false,
      newPfNames: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
      newPfs: [],

      userPfList: [],
      _allShowList: [],
      chooseUserPf: [],
      curActiveUpfIdx: -1,
      curActiveUpf: null,

      showDelConfirm: false,
      delUserPf: null,
      spots: [],
      spotIdx: 0
    }
  },
  async created () {
    if (!this.$store.state.label.list.length) await this.$store.dispatch('label/getSearchLabels') // 标签Label
    this.getSexData() // 男女比例数据
    this.getOrdersUPFs() // 用户画像数据
  },
  methods: {
    chooseActive (item) {
      if (this.curActiveUpf === item) return
      this.curActiveUpf = item
      this.curActiveUpfIdx = this.userPfList.indexOf(item)
      this.$nextTick(() => {
        if (item.state != 1) this.showBar(item) // item.state 为1 时为计算中状态不请求
      })
    },
    async handleDelUserPf () {
      let opt = { orderCodes: (this.codes || '').split(','), updateLabelCodesMap: {} }
      opt.updateLabelCodesMap[this.delUserPf.list.map(el => el.code).join(',')] = []
      let res = await this.fetch('/dsp/web/order/v2/orderTargetInfo', opt, 'post')
      if (res && res.code == this.successCode) {
        let delPf = this.delUserPf
        if (delPf === this.curActiveUpf) {
          this.curActiveUpf = null
          this.curActiveUpfIdx = -1
        }
        this.userPfList.splice(this.userPfList.indexOf(delPf), 1)
        this.delCancel()
      }
    },
    delCancel () {
      this.showDelConfirm = false
      this.delUserPf = null
    },
    clickDelUserPf (item) {
      this.delUserPf = item
      this.showDelConfirm = true
    },
    async getSexData () {
      // this.codes = 'D1584093417251'
      // this.time = ['2020-03-14', '2020-04-15']
      let orderCodeList = this.codes ? this.codes.split(',') : []
      let res = await this.fetch(
        '/adr/order/v2/advert-compose-label-flowrates',
        { orderCodeList: this.codes || '', startDate: this.time[0], endDate: this.time[1] },
      'get')
      if (res && res.code == this.successCode && res.data && res.data.length) {
        let data = this.handleAllSexData(res.data)
        this.$set(this.sexData, 'list', data)
        this.activeSexData = data[0]
      } else {
        this.$set(this.sexData, 'list', [])
        this.activeSexData = { title: '', list: [] }
      }
    },
    setBarOption (data) {
      let xTime = data.map(el => el.timeRemark)
      let { history, today } = data.reduce((res, el) => {
        el.num = (el.todayNum || 0) + (el.historyNum || 0)
        res.history.push(el.historyNum || 0)
        res.today.push(el.todayNum || 0)
        return res
      }, { history: [], today: [] })
      let vm = this
      let label = () => {
        return {
          normal: {
            show: true, position: 'top', align: 'center', // distance: 2,
            formatter (p) {
              let item = data[p.dataIndex]
              let { todayNum, num } = data[p.dataIndex]
              let td = new Date().setHours(0,0,0,0)
              let hasTodayData = new Date(vm.time[1]).getTime() >= td && new Date(vm.time[0]).getTime() <= td
              return hasTodayData ? `+{red|${todayNum}}\n{black|${num}}` : `{black|${num}}`
            },
            rich: {
              red: { color: '#FA1B73', fontSize: '12px', lineHeight: 25 },
              black: { color: '#3B3F45' }
            }
          }
        }
      }
      let cvsSet = { // 线条相关配置
        // boundaryGap: false, // x y轴起点在一起
        axisLine: { show: false, lineStyle: { color: '#878A92', type: 'dashed' } },
        splitLine: { show: true, lineStyle: { color: '#e9e9e9', type: 'dashed' } },
        axisTick: { lineStyle: { color: '#FFF' } }
      }
      let barCfg = { stack: '总量', name: '历史触达人次', type: 'bar', data: history, barWidth: '10' }
      let barChart = echarts.init(this.$refs.Bar)
      barChart.setOption({
        color: ['#3083F2', '#FA1B73'],
        legend: { selectedMode: false, data: ['历史触达人次', '今日新增人次'], bottom: 0 }, // 点击功能 label显示有问题 selectedMode 设置为 false
        grid: {
          left: '0%', right: '0%', top: 40, bottom: '9%', containLabel: true
        },
        xAxis: [{ type: 'category', data: xTime, ...cvsSet }],
        yAxis: [{ type: 'value', ...cvsSet }],
        series: [
          { ...barCfg, data: history, name: '历史触达人次' },
          { ...barCfg, data: today, name: '今日新增人次', label: label() }
        ]
      })
      barChart.resize()
      let fn = () => {
        if (this.$refs.Bar) barChart.resize()
        else window.removeEventListener('resize', fn)
      }
      window.addEventListener('resize', fn)
    },
    async showBar (item) { // 趋势图形
      // this.codes = 'D1586509641040'
      let orderCodeList = this.codes || ''
      let res = await this.fetch(`/adr/order/v2/advert-target-flowrates`, {
        orderCodeList, labels: item.targetInfoList.join(','),
        startDate: this.time[0], endDate: this.time[1]
      }, 'get')
      if (res && res.code == this.successCode) {
        let data = res.data || []
        this.setBarOption(data)
      } else {
        this.setBarOption([])
      }
    },
    handleListHide () {
      let idx = this.spotIdx
      let showS = idx * 3
      this.userPfList.forEach((el, i) => {
        if (i >= showS && i < showS + 3) this.$set(el, 'show', true)
        else this.$set(el, 'show', false)
      })
    },
    clickSpot (i) {
      if (this.spotIdx === i) return
      this.spotIdx = i
      this.handleListHide()
      if (this.curActiveUpf) {
        this.curActiveUpf = null
        this.curActiveUpfIdx = -1
      }
    },
    async getOrdersUPFs () {
      // this.codes = 'D1586509641040'
      let res = await this.fetch(`/dsp/web/order/v2/orderTargetInfo`, {
        orderCodes: this.codes || '', startDate: this.time[0], endDate: this.time[1]
      }, 'get')
      if (res && res.code == this.successCode) {
        let data = res.data || []
        if (data.length) {
          this.spots.length = Math.floor(data.length / 3) + ( data.length % 3 > 0 ? 1 : 0 )
          this.userPfList = data.map(el => {
            el.show = false // 默认都不可见
            return el
          })
          this.handleListHide() // 第一组展示
          this.clickSpot(0) // 选中第一组第一个
          // 展示柱状图
          this.changeUFListData()
          this.chooseActive(data[0])
        }
      } else {
        this.spots.length = 0
        this.spotIdx = 0
        this.userPfList = []
      }
    },
    changeUFListData () {
      let codeMap = this.$store.state.label.codeMap
      this.userPfList.forEach(el => {
        el.targetInfoList = el.targetInfoList || []
        el.list = el.targetInfoList.map(el => {
          return codeMap[el] || {}
        })
      })
    },
    numAdd (list, key) {
      key = key || 'num'
      return list.reduce((res, cur) => (cur[key] || 0) * 100 - 0 + res, 0) / 100   // *100 /100 防止精度问题 0.1 + 0.2 == 0.300000004
    },
    handleAllSexData (list) {
      let allNum = this.numAdd(list)
      let ageTypeNames = this.$store.state.label.sortMap['AGE'].map(el => el.name)
      return ageTypeNames.map(name => {
        let nameData = list.filter(ele => ele.labelName.indexOf(name) > -1) // 当前年龄段下 男女数据
        // 时间段分组 和 男女类型名称分组
        let { times, labelTypes } = nameData.reduce((res, cur) => {
          if (res.times.indexOf(cur.timeSegmentName) == -1) res.times.push(cur.timeSegmentName)
          // let curLabel = cur.labelName.split('||')[0] // 0 是 男性 女性
          let curLabel = cur.labelName.split('||')[1] // 1 是 年龄
          if (res.labelTypes.indexOf(curLabel) == -1) res.labelTypes.push(curLabel)
          return res
        }, { times: [], labelTypes: [] })
        let curAllNum = this.numAdd(nameData) // 当前list总num
        let nameTimeList = times.map(time => {
          let curAllList = nameData.filter(el => el.timeSegmentName == time) // 当前时段下男女数据
          let fData = curAllList.filter(el => el.labelName.indexOf('男') > -1)
          let mData = curAllList.filter(el => el.labelName.indexOf('女') > -1)
          let maleNum = this.numAdd(mData), femaleNum = this.numAdd(fData)
          return {
            name: time, femaleNum, maleNum,
            rateMale: curAllNum ? maleNum / curAllNum : 0, rateFemale: curAllNum ? femaleNum / curAllNum : 0
          }
        })
        return {
          name, title: name, list: nameTimeList,
          rateMale: allNum ? this.numAdd(nameTimeList, 'maleNum') / allNum : 0,
          rateFemale: allNum ? this.numAdd(nameTimeList, 'femaleNum') / allNum : 0
        }
      })
    }
  }
}
</script>
